<script lang="ts">
  import { onMount } from "svelte";
  import {
    deleteFacilitator,
    deleteParticipant,
    getFacilitators,
    getParticipants,
    getProject,
  } from "../services/project";
  import Loading from "../components/Loading.svelte";
  import ProjectTabs from "../components/ProjectTabs.svelte";
  import CreateParticipant from "../components/CreateParticipant.svelte";
  import { fade } from "svelte/transition";
  import page from "page";
  import { pageTitle } from "../stores/store";
  export let projectId;
  let participants;
  let dangerEnabled = false;
  onMount(async () => {
    participants = await getParticipants(projectId);
    let project = await getProject(projectId);
    if (project.errors) {
      page.redirect("/projects");
    }
    $pageTitle = project.name;
  });
  const onAdded = async () => {
    participants = await getParticipants(projectId);
  };
  const deleteUser = async (user) => {
    const result = await deleteParticipant(projectId, user.email);
    if (result && result.success) {
      participants = participants.filter((f) => {
        return f.email != user.email;
      });
    }
  };
</script>

<ProjectTabs {projectId} />
<div class="panel" class:show-danger={dangerEnabled}>
  <div class="grid">
    <div class="cell is-first">
      {#if participants}
        <table style="max-width:500px">
          <thead>
            <th>Email address</th>
            <th
              class="is-danger"
              on:click={() => {
                dangerEnabled = !dangerEnabled;
              }}
              width="160">Danger zone</th
            >
          </thead>
          <tbody>
            {#each participants as f, index (f._id)}
              <tr>
                <td>
                  {f.email}
                </td>

                <td class="is-danger">
                  <button
                    class="btn"
                    on:click={() => {
                      deleteUser(f);
                    }}>Delete</button
                  >
                </td>
              </tr>
            {/each}
            {#if participants.length === 0}
              <tr>
                <td colspan="2">No participants have been created</td>
              </tr>
            {/if}
          </tbody>
        </table>
      {:else}
        <Loading />
      {/if}
    </div>
    <div class="cell">
      <CreateParticipant {projectId} on:created={onAdded} />
    </div>
  </div>
</div>

<style lang="scss">
  div.is-first {
    padding-right: 3rem;
  }
</style>
